import { InnerBox } from "@/components/elements/InnerBox";
import { Box, Stack, Typography } from "@mui/material";
import { FC } from "react";
import { JobFormTitle } from "@/features/job/components/job-form/JobFormTitle";
import { TJobForm } from "@/features/job/types/JobForm";
import { FileItem } from "@/components/elements/FileItem";
import dayjs from "dayjs";
import { YEAR_MONTH_DAY_STR_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { text } from "@/theme/colors";

type JobUploadFileDetailProps = {
  defaultValues?: Partial<TJobForm>;
};

export const JobUploadFilesDetail: FC<JobUploadFileDetailProps> = ({ defaultValues }) => {
  return (
    <Stack gap={2}>
      <InnerBox title={<JobFormTitle text="その他関連情報" />} padding="24px" showDivider={false}>
        {defaultValues?.jobUploadFiles?.length ? (
          <Stack>
            {defaultValues?.jobUploadFiles?.map((item, idx) => (
              <Box
                key={idx}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 2,
                  mt: 1,
                }}
              >
                <FileItem
                  filePath={item.filePath}
                  hideIcon={true}
                  title={item.title}
                  currentFileIndex={idx}
                  files={defaultValues?.jobUploadFiles}
                  previewEnabled
                  downloadable
                  iconDownloadable={true}
                />
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography variant="body2" color={text.secondary} sx={{ whiteSpace: "nowrap", pl: 1 }}>
                    {item.createdAt ? dayjs(item.createdAt).format(YEAR_MONTH_DAY_STR_FORMAT) : ""} 更新
                  </Typography>
                </Stack>
              </Box>
            ))}
          </Stack>
        ) : <Typography>{EMPTY_STR.TEXT}</Typography>}
      </InnerBox>
    </Stack>
  );
};
